import { render, staticRenderFns } from "./CreatePayment.vue?vue&type=template&id=9ff5230c&"
import script from "./CreatePayment.vue?vue&type=script&lang=ts&"
export * from "./CreatePayment.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePayment.vue?vue&type=style&index=0&id=9ff5230c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports